import { z } from 'zod';
import { IsoDateTimeSchema, ModuleCodeSchema, NullableUrlSchema, RoleSchema, UuidSchema } from './common.js';
export const LoginRequestSchema = z.object({
    email: z.string().email().toLowerCase().trim(),
    password: z.string().min(8).max(128),
});
export const SessionUserSchema = z.object({
    id: UuidSchema,
    email: z.string().email(),
    nombreCompleto: z.string().nullable(),
    rol: RoleSchema,
    sucursalId: UuidSchema.nullable(),
    startupModule: ModuleCodeSchema.nullable(),
    needsPasswordChange: z.boolean(),
    avatarUrl: NullableUrlSchema,
});
export const LoginResponseSchema = z.object({
    user: SessionUserSchema,
    csrfToken: z.string().min(32),
    expiresAt: IsoDateTimeSchema,
    passwordChangeToken: z.string().optional(),
});
export const RefreshResponseSchema = z.object({
    csrfToken: z.string().min(32),
    expiresAt: IsoDateTimeSchema,
});
export const PasswordResetRequestSchema = z.object({
    userId: UuidSchema,
});
export const PasswordResetResponseSchema = z.object({
    token: z.string().min(32),
    expiresAt: IsoDateTimeSchema,
});
export const SetPasswordRequestSchema = z.object({
    token: z.string().min(32),
    password: z.string().min(8).max(128),
});
//# sourceMappingURL=auth.js.map